// extracted by mini-css-extract-plugin
export default {"cropOption":"SZGcWy2OpcuoFUOk7qtN","replaceOption":"vdGVy4CaVvLUPHgnbBWL"};